var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CustomSelect',{attrs:{"value":_vm.getValue,"options":_vm.companies,"placeholder":'Välj företag',"trackBy":'name',"show-load-more":_vm.companiesHasMore,"loading":_vm.dropdownIsLoading},on:{"select":_vm.setSelectedCompany,"search":_vm.searchCompany,"on-load-more":_vm.loadMoreCompanies}})
}
var staticRenderFns = []

export { render, staticRenderFns }